import React from "react";
import { useTranslation } from "react-i18next";
import AppButton from "components/ui/AppButton";
import StoreViewController from "features/store/containers/viewController";

const LaunchStore = ({ onSaveAndContinue }) => {
  const { t } = useTranslation();
  const footer = (
    <div className="flex justify-end">
      <AppButton onClick={() => onSaveAndContinue?.()}>
        {t("Save & Continue")}
      </AppButton>
    </div>
  );

  return (
    <StoreViewController as="component" defaultMode="list" onSaveAndContinue={onSaveAndContinue} title="Launch Store" subTitle="launch_store_dashboard_list_hint" footer={footer} />
  );
};

export default LaunchStore;
